module.exports = __webpack_public_path__ + "static/media/003.2e2e6021.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/003.jpg
// module id = 350
// module chunks = 0